<template>
  <div id="contentDetailModal" class="content">
    <modal :show.sync="shouldShow" @hidden="onClickCancel" v-on:close="onClickCancel" footerClasses="justify-content-center" type="notice">
      <h4 slot="header" class="modal-title">
        <b>띄워주기</b>
      </h4>
      <div class="row">
        <div class="col-sm-3">
          <h4 class="card-title text-left">타입</h4>
          <div class="row">
            <div class="col-md-12 text-left">
              <el-select @change="changeType" class="select-primary" size="large" placeholder="선택" v-model="types.type">
                <el-option v-for="option in types.options" class="select-primary" :value="option.value" :label="option.label" :key="option.label"></el-option>
              </el-select>
            </div>
          </div>
        </div>
      </div>
      <MemberSelect
        class="member-select"
        v-if="types.type === 4"
        multiple
        :whitelist="members"
        :unitId="unitId"
        v-model="memberIds"
        v-on:change="getArtistInfo"
      ></MemberSelect>

      <div slot="footer" class="justify-content-center">
        <base-button class="footer-buttons col-6" type="success" round @click.native="onClickConfirm">확인</base-button>
        <base-button class="footer-buttons col-6" type="danger" round @click.native="onClickCancel">취소</base-button>
      </div>
    </modal>
  </div>
</template>
<script>
import { Modal } from "@/components/index";
import BaseButton from "@/components/BaseButton";
import MemberSelect from "@/pages/Components/MemberSelect.vue";

export default {
  name: "RadarContentDetailModal",
  components: {
    BaseButton,
    Modal,
    MemberSelect,
  },
  data() {
    return {
      startTime: null,
      endTime: null,
      weight: 5,
      memberIds: [],
      types: {
        type: 1,
        options: [
          {
            label: "인기트렌드",
            value: 1,
          },
          {
            label: "푸쉬알림",
            value: 4,
          },
        ],
      },
    };
  },
  props: {
    members: Array,
    unitId: Number,
    contentId: Number,
    shouldShow: {
      type: Boolean,
      required: true,
    },
    onConfirm: {
      type: Function,
      required: true,
    },
    onCancel: {
      type: Function,
      required: true,
    },
  },
  methods: {
    changeType() {},
    onClickConfirm: async function () {
      await this.onConfirm();
      const param = {};
      let url = "";

      param.unitId = this.unitId;
      if (this.types.type === 1) {
        param.members = this.members;
        url = `/radarContent/${this.contentId}/hotContent`;
        return this.$axios
          .post(url, param)
          .then((res) => {
            window.Toast.success("설정되었습니다");
            this.startTime = null;
            this.endTime = null;
            this.weight = 5;

            this.onClickCancel();
          })
          .catch((error) => {
            window.Toast.error(error.response.data.error.message);
          });
      } else if (this.types.type === 4) {
        param.memberIds = this.memberIds;
        url = `/radarContent/${this.contentId}/notification`;
        return this.$axios
          .put(url, param)
          .then((res) => {
            window.Toast.success("푸시알림이 전송되었습니다");

            this.onClickCancel();
          })
          .catch((error) => {
            window.Toast.error(error.response.data.error.message);
          });
      }
    },
    onClickCancel: async function () {
      await this.onCancel();
    },
    getArtistInfo(memberId) {
      this.memberIds = memberId;
    },
  },
};
</script>
<style lang="scss">
#contentDetailModal .modal-dialog {
  max-width: 800px !important;
}

.member-select {
  margin-bottom: 30px;
}

.footer {
  .footer-buttons {
    width: 100px;
  }
}
</style>
